var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCommonError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.5 116V70H99.5V116H101.5ZM101.5 130V124H99.5V130H101.5Z",
    fill: "#59BD39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.5 100C165.5 116.787 159.104 132.943 147.612 145.18C136.121 157.417 120.398 164.816 103.644 165.87C86.8906 166.924 70.3647 161.554 57.4302 150.854C44.4957 140.154 36.1246 124.927 34.0206 108.272C31.9167 91.6177 36.238 74.7873 46.1051 61.2064C55.9722 47.6255 70.6435 38.3148 87.133 35.1692C103.623 32.0237 120.691 35.2797 134.865 44.2746C149.038 53.2694 159.252 67.3272 163.427 83.5867",
    stroke: "#1B1B1B",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCommonError);
export default ForwardRef;